import CssBaseline from "@mui/material/CssBaseline";
import GlobalStyles from "@mui/material/GlobalStyles";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import React from "react";
import getDesignTokens from "./styles/tokens";
export const ThemeContext = React.createContext({
  toggleColorMode: () => {},
});

type MyThemeProviderProps = {
  children?: React.ReactNode;
};

export default function MyThemeProvider(props: MyThemeProviderProps) {
  const savedPref = localStorage.getItem("mode");
  let savedMode: "light" | "dark" = "light";
  if (savedPref === "light" || savedPref === "dark") {
    savedMode = savedPref;
  }
  const [mode, setMode] = React.useState<"light" | "dark">(savedMode);

  const colorMode = React.useMemo(
    () => ({
      toggleColorMode: () => {
        localStorage.setItem("mode", mode === "light" ? "dark" : "light");
        setMode((prevMode) => (prevMode === "light" ? "dark" : "light"));
      },
    }),
    [mode]
  );

  const theme = createTheme(getDesignTokens(mode));

  return (
    <ThemeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <GlobalStyles styles={{}} />
        <CssBaseline enableColorScheme />
        {props.children}
      </ThemeProvider>
    </ThemeContext.Provider>
  );
}
